import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor tag
 */
export default class TagSeoValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.label
   * @param {String} deps.link
   * @param {String} deps.title
   */

  constructor({label, link, title}) {
    super({label, link, title})
  }

  /**
   * @return {Object}
   */
  toJSON() {
    return {
      label: this._label,
      link: this._link,
      ...(this._title && {title: this._title})
    }
  }
}
